import { createActions, createReducer } from 'reduxsauce'

import ConsultaRemuneracaoADMRHService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaServidoresFuncoesGratificadasInicio: [],
    buscaConsultaServidoresFuncoesGratificadasErro: ['erro'],
    buscaConsultaServidoresFuncoesGratificadasSucesso: ['consultaServidoresFuncoesGratificadas'],
    limpar: [],
    setConsultaServidoresFuncoesGratificadasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.consultarQuadrosMembros = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaServidoresFuncoesGratificadasInicio())
        let serv = new ConsultaRemuneracaoADMRHService()
        return serv
            .consultarQuadrosMembrosFgcc(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaServidoresFuncoesGratificadasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaServidoresFuncoesGratificadasErro(error)))
    }
}

const buscaConsultaServidoresFuncoesGratificadasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaServidoresFuncoesGratificadasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaServidoresFuncoesGratificadasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaServidoresFuncoesGratificadas.resultado,
        dataSincronizacaoDados: action.consultaServidoresFuncoesGratificadas.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaServidoresFuncoesGratificadasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_SERVIDORES_FUNCOES_GRATIFICADAS_INICIO]: buscaConsultaServidoresFuncoesGratificadasInicio,
    [Types.BUSCA_CONSULTA_SERVIDORES_FUNCOES_GRATIFICADAS_ERRO]: buscaConsultaServidoresFuncoesGratificadasErro,
    [Types.BUSCA_CONSULTA_SERVIDORES_FUNCOES_GRATIFICADAS_SUCESSO]: buscaConsultaServidoresFuncoesGratificadasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_SERVIDORES_FUNCOES_GRATIFICADAS_ESTADO_DT]: setConsultaServidoresFuncoesGratificadasEstadoDT,
})
